import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'formatReminderDate',
  pure: true,
  standalone: false
})
export class FormatReminderDatePipe implements PipeTransform {
  transform(date: dayjs.Dayjs, language: string): string {
    const dateOptions: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' };
    const languages = {
      fr: 'fr-CH',
      en: 'en-GB',
      de: 'de-CH'
    };
    return date.toDate().toLocaleDateString(languages[language] as string, dateOptions);
  }
}
